import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

/**
 * Send email request.
 * @param data
 * @param {String} data.To
 * @param {String} data.Cc
 * @param {String} data.Bcc
 * @param {String} data.Subject
 * @param {String} data.Body
 * @param {Array} [data.files]
 * @returns {AxiosPromise<any>}
 */
export const requestSendEmail = (data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
        if (key === "files") {
            if (Array.isArray(data[key])) {
                data[key].forEach(file => {
                    formData.append("files", file);
                });
            }
        } else {
            formData.set(key, data[key]);
        }
    });
    return axios.post(`${apiUrl}email`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
};

export const requestGetEmployeeEmails = (jobId, dateFrom, dateTo) =>
    axios.get(`${apiUrl}employees/byJob?jobId=${jobId}&fromDate=${dateFrom}&toDate=${dateTo}`);
